import { render, staticRenderFns } from "./index.vue?vue&type=template&id=699ab45b&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadcrumbs: require('/app/components/app/Breadcrumbs.vue').default,StoreSearchPanel: require('/app/components/store/SearchPanel.vue').default,StoreVariantCard: require('/app/components/store/VariantCard.vue').default,BaseMap: require('/app/components/base/Map.vue').default,BaseIcon: require('/app/components/base/Icon.vue').default,StoreInfo: require('/app/components/store/Info.vue').default})
